import { application } from "./application"

import AdminLayoutController from "./admin_layout_controller"
import ApexChartController from "./apex_chart_controller"
import MenuSortableController from "./menu_sortable_controller"
import MetismenuController from "./metismenu_controller"
import PasswordToggleController from "./password_toggle_controller"
import PermissionTreeController from "./permission_tree_controller"
import RecaptchaController from "./recaptcha_controller"
import RichTextController from "./rich_text_controller"
import SwiperSliderController from "./swiper_slider_controller"

application.register("admin-layout", AdminLayoutController)
application.register("apex-chart", ApexChartController)
application.register("menu-sortable", MenuSortableController)
application.register("metismenu", MetismenuController)
application.register("password-toggle", PasswordToggleController)
application.register("permission-tree", PermissionTreeController)
application.register("recaptcha", RecaptchaController)
application.register("rich-text", RichTextController)
application.register("swiper-slider", SwiperSliderController)
